/**
 * 認証、認可情報の mutaions
 */
const mutations = {
  /**
   * 検索条件を変更します
   */
  condition: (state, payload) => {
    state.condition = payload.condition;
  },
  /**
   * 経路情報を変更します
   */
  routes: (state, payload) => {
    state.routes = payload.routes;
  },
  /**
   * 経路詳細情報を変更します
   */
  route: (state, payload) => {
    state.route = payload.route;
  },
  /**
   * 経路種別情報を変更します
   */
  routeType: (state, payload) => {
    state.routeType = payload.routeType;
  },
  /**
   * ルートサマリ表示判定を変更します
   */
  visibleSummary: (state, payload) => {
    state.visibleSummary = payload.visibleSummary;
  },
  /**
   * ルート詳細表示判定を変更します
   */
  visibleDetail: (state, payload) => {
    state.visibleDetail = payload.visibleDetail;
  },
};

export { mutations as default };
